import styled from "styled-components";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import loginBg from "assets/images/backgrounds/login.jpg";

const signWidth = "400px";
export const BackgroundImage = `url(${loginBg}), url("/login.jpg")`;

export const ExpiredWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  flex: 1;
  flex-direction: column;
  gap: 10px;
  padding: 15px 0;
  color: ${COLORS.WARNING};

  span {
    font-size: ${calcRem(13)};
  }
`;

export const BG = styled.div<{ noticeHeight: number }>`
  width: 100%;
  min-height: ${({ noticeHeight = 0 }) => `
    calc(100dvh - ${noticeHeight}px);
  `};
  padding: 20px;
  background: no-repeat fixed center center;
  background-image: ${BackgroundImage};
  background-size: cover;
  ${FLEX.FlexCenterCenter};
  .signup-container {
    padding-bottom: 100px;
  }
`;

export const Container = styled.div`
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  flex: 1;
  .validate-word {
    text-align: left;
  }
  ${mediaQuery.isMobile} {
    height: 100%;
  }
  /* min-height: 100vh; */
`;

export const LoginWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  padding: 100px 0;
`;

export const Logo = styled.div``;

export const commonLoginHeight = "40px";

export const LoginBox = styled.section`
  background-color: ${(props) =>
    props.theme.value === "light" ? COLORS.WHITE : "#161d27"};
  border-radius: 10px;
  box-shadow: 0px 9px 6px #00000029;
  text-align: center;
  padding: 30px 45px;
  ${mediaQuery.isDefault} {
    width: ${signWidth};
    min-height: 300px;
  }

  ${mediaQuery.isMobile} {
    width: 400px;
    max-width: 90vw;
    padding: 30px 25px;
  }
  .mydw-logo {
    margin-bottom: 30px;
  }

  .title-wrapper {
    ${FLEX.FlexBetweenCenter};
  }

  .title {
    font-size: ${calcRem(16)};
    font-weight: 500;
    color: ${(props) => props.theme.COLORS.WHITE};
    margin-bottom: 26px;
    text-align: center;
  }

  .description {
    font-size: ${calcRem(14)};
    color: ${COLORS.BUTTONS1};
    margin-bottom: 10px;
    line-height: ${calcRem(18)};
  }

  .description > strong {
    color: ${(props) => props.theme.COLORS.WHITE};
    font-weight: normal;
  }
  label {
    font-size: ${calcRem(14)};
  }
  input[type="checkbox"] {
    width: 14px;
    height: 14px;
  }
`;

export const InputWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;

  > input {
    padding: 12px;
    height: ${commonLoginHeight};
    font-size: ${calcRem(14)};
  }
`;

export const BigButton = styled.button<{ dw?: boolean; cancel?: boolean }>`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.value === "light" ? COLORS.COMPANY : COLORS.BUTTONS2};
  border-radius: 4px;
  color: ${COLORS.WHITE};
  font-weight: 500;
  /* padding: 18px; */
  height: ${commonLoginHeight};
  font-size: ${calcRem(14)};
  ${FLEX.FlexCenterCenter};
  gap: 4px;

  &:disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }

  > button,
  > span {
    position: relative;
    ${FLEX.FlexCenterCenter};
    color: ${COLORS.WHITE};
    > img {
      width: 13px;
    }
  }
  ${({ dw }) =>
    dw &&
    `
    background-color:#F66214;
  `}
  ${({ cancel }) =>
    cancel &&
    `
    background-color: ${COLORS.BUTTONS1};
  `}
`;

export const EmailBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: ${calcRem(12)};
  border-radius: 14px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  padding: 8px 24px;
  margin: 8px 0 16px;
`;

export const Bottom = styled.div<{ center?: boolean }>`
  width: 100%;
  ${({ center }) => (center ? FLEX.FlexCenterCenter : FLEX.FlexBetweenCenter)};
  gap: 10px;

  .go-back-link {
    color: ${COLORS.BUTTONS1};
    text-decoration: underline;
    font-size: ${calcRem(14)};
  }
`;

export const MarginBottom = styled(Bottom)`
  flex-direction: column;
  ${mediaQuery.isDefault} {
    margin-top: 38px;
  }
  ${mediaQuery.isMobile} {
    margin-top: 20px;
  }
`;

export const CenterBox = styled.div`
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 10px;
  padding: 15px 0;
`;

export const LoginInputBadgeWrapper = styled.div`
  ${FLEX.FlexBetweenCenter};
  margin-top: 0.875rem;
`;

export const ValidateWrapper = styled.span`
  width: 100%;
  ${FLEX.FlexStartCenter};
  font-size: ${calcRem(12)};
  padding: 6px 0;
  text-align: left;
  /* margin-top: -1px; */
`;

export const VerifyWrapper = styled.div`
  width: 100%;
  height: 100dvh;
  ${FLEX.FlexCenterCenter};
`;

export const VerifyInner = styled.div`
  width: ${signWidth};
  border: 1px solid red;
`;
